export default __webpack_public_path__ + "static/media/vca-logo_image.91fabc9b.png";